'use strict'

import PopIn from './Popin'

//Gestion de la galerie de portraits
//pour la versions Desktop

const Portraits =  {
    elements: document.querySelectorAll(".portraits--people"),
    portraits: document.querySelectorAll(".portraits--people .people"),
    result:'',
    lines: 0,
    numberElement: 0,
    infoTablet: '',
    //  
    init: function(){
        this.numberElement = this.elements.length; 

        //version tablet / mobile
        if(window.innerWidth < 768){
            let resteMobile =  this.numberElement -  this.numberElement%3;
            this.createGridTablet(resteMobile, this.numberElement)
            //this.showInfoPortraitMobile()
        }
        //si version Desktop
        else{
            //
            // let reste =  this.numberElement -  this.numberElement%4;
            // this.createGridDesktop(reste, this.numberElement)
        }

        
    },
    createGridDesktop: function(value){
       // console.clear();
        let lastLine = this.numberElement-value;
        let preLine = 0; // avant derniere ligne
     
        if(value > 7){
            if(lastLine === 1){
                lastLine = lastLine+4
                if(value > 8){
                    value = value-8
                    preLine = preLine+4
                }
                else{
                    value = value-4
                }
            }
            else if(lastLine === 2){
                lastLine = lastLine+3
                if(value > 8){
                    value = value-(4+4)
                    preLine = preLine+5
                }
                else{
                    value = value-3
                } 
            }
            else if(lastLine === 3){
                lastLine = lastLine+3
                if(value > 8){
                    preLine = preLine+5
                    value = value-(4+4)
                }  
                else{
                    value = value-3
                }
            }
        }
        else{
          value = value + lastLine
          lastLine = lastLine-lastLine
        }
        
        // console.log("value: "+value+" | preligne: "+ preLine + " | lastLine :"+ lastLine );
        //Redimentionner les différents éléments 
        this.resizeElementsDesktop(value,preLine,lastLine);
    },
    resizeElementsDesktop: function(value,preLine,lastLine) {
        this.value = value
        this.preLine = preLine
        this.lastLine = lastLine
        this.valPlusPreLine = this.value + this.preLine+1
        this.allLines = this.value + this.preLine + this.lastLine+1
      
        if(this.value%4 === 0 && this.preLine === 0 & this.lastLine === 0 || this.value < 5 && this.preLine === 0 & this.lastLine === 0){
            for(let i= 1; i< this.value+1; i++){
                document.querySelector(".portraits--people:nth-child(" + i + "n+"+ i + ")").style.width = 100/4 +"%";
            } 
        }
        else if(this.preLine === 0 & this.lastLine === 0){
            for(let i= 1; i< this.value+1; i++){
                document.querySelector(".portraits--people:nth-child(" + i + "n+"+ i + ")").style.width = 100/this.value +"%";
            } 
        }
        else if(this.preLine > 0){
            //before Line  
            for(let i= 1; i< this.value+1; i++){
            document.querySelector(".portraits--people:nth-child(" + i + "n+"+ i + ")").style.width = 100/4 +"%";
            }
            //preline
            for(let i= this.value+1; i< this.valPlusPreLine; i++){
                document.querySelector(".portraits--people:nth-child(" + i + "n+"+ i + ")").style.width = 100/this.preLine +"%";
            }
            //lastline
            for(let i= this.valPlusPreLine; i< this.allLines; i++){
                document.querySelector(".portraits--people:nth-child(" + i + "n+"+ i + ")").style.width = 100/this.lastLine +"%";
            }
        }
        else{ 
            //before Line  
            for(let i= 1; i < this.value+1; i++){
                document.querySelector(".portraits--people:nth-child(" + i + "n+"+ i + ")").style.width = 100/(this.value) +"%"; 
            }
        
            for(let i= this.valPlusPreLine; i < this.allLines; i++){
                document.querySelector(".portraits--people:nth-child(" + i + "n+"+ i + ")").style.width = 100/this.lastLine +"%";
            }
        }
    },
    createGridTablet : function(value){
        //console.clear();
        //console.log("version Tablet / mobile ")
        let lastLine = this.numberElement-value;
        let preLine = 0; // avant derniere ligne
        //console.log(" AVANT : value: "+value+" | preligne: "+ preLine + " | lastLine :"+ lastLine );
        //simplification de la version Desktop 
        // on établit la grille
        if(value === 3  && preLine == 0 && lastLine === 1){
            value = 0
            // preLine = 2
            preLine = 3
            lastLine = 2
        }
        else if(value === 3 && preLine == 0 && lastLine === 2){
            value = 0
            preLine = 3
            lastLine = 2
        }   
        else if(value > 3 && preLine == 0 && lastLine === 1){
            value = value - 3
            // preLine = 2
            preLine = 3
            lastLine = 2
        }
        else if(value > 3 && preLine == 0 && lastLine === 2){
            value = value - 3
            preLine = 3
            lastLine = 2
        }

        //console.log("value: "+value+" | preligne: "+ preLine + " | lastLine :"+ lastLine );
        this.resizeElementsTablet(value, preLine, lastLine)
        
    },
    resizeElementsTablet: function(value, preLine, lastLine){
        this.value = value
        this.preLine = preLine
        this.lastLine = lastLine
        this.total = value + preLine + lastLine

        // on resize les blocs
        //  + creation des blocs d'informations 
        /*for(let i=1; i<=this.total;i++){
            //valeur base
            document.querySelector(".portraits--people:nth-child(" + i + ")").style.width = 100/3 +"%";
            // if(i <= this.value){
            //     document.querySelector(".portraits--people:nth-child(" + i + ")").style.width = 100/3 +"%";
            // }
            // //preLine
            // else if( i > this.value && i <=  ( this.value + this.preLine)){
            //     document.querySelector(".portraits--people:nth-child(" +  i + ")").style.width = 100/this.preLine +"%"
            // }
            // //lastLine
            // else if( i > ( this.value + this.preLine -1) ) {
            //     document.querySelector(".portraits--people:nth-child(" + i + ")").style.width = 100/this.lastLine+"%"
            // }
        }*/
        //console.log(this.portraits)
        this.placeInfosTablet(value, preLine, lastLine)
    },
    createInfosTablet: function(){
        //console.clear()
        // A creer
        //creation de l'espace d'info
        this.infoTablet = document.createElement("li")
        this.infoTablet.classList.add("people--infosTablet")
        
        //creation du nom
        let peopleName = document.createElement("div")                      
        peopleName.classList.add("people--name")
        this.infoTablet.appendChild(peopleName)
        //creation du titre de poste
        let peoplePost = document.createElement("div")
        peoplePost.classList.add("people--poste")
        this.infoTablet.appendChild(peoplePost)   
        //end 
    },
    placeInfosTablet: function (value, preline, lastLine){
        let place = []
        // place pour les premieres lignes
        for( let i = 3; i <= value ; i = i+3){
           place.push(i)
        }
        place.push(value + preline)   // après "preline"
        place.push(value + preline + lastLine) // après la dernière ligne
        
        // afficher le prochain bloc d'info
        //créer le bloc info au bon endroit
        const placement = place.values()
        
        for(const p of placement){
            // 
            this.createInfosTablet()
            //
            let parDiv = document.querySelector("ul.portraits--content")
            parDiv.insertBefore( this.infoTablet, this.elements[p])
            
            this.infoTablet.addEventListener("click", function() {
                //console.log(document.querySelector('.portraits--people.actif > div'));
                let myPopIn = new PopIn(document.querySelector('.portraits--people.actif > div'));
                myPopIn.create()
            });
        }
    },
    infoPortraitMobile: function (portrait) {
        let nextElt = this.nextElement(portrait, '.people--infosTablet')
        // let _listener = function() {
        //     console.log(document.querySelector('.portraits--people.actif'));
        //     let myPopIn = new PopIn(document.querySelector('.portraits--people.actif > div'));
        //     myPopIn.create()
        // }
        //nextElt.removeEventListener("click", _listener);

        if(!portrait.classList.contains("actif")) { //on active
            document.querySelector("ul.portraits--content").classList.add('open');
            if(document.querySelector('.portraits--people.actif')) {
                document.querySelector('.portraits--people.actif').classList.remove('actif');
            }
            if(document.querySelector('.people--infosTablet.actif')) {
                document.querySelector('.people--infosTablet.actif').classList.remove('actif');
            }
            portrait.classList.add("actif")
            nextElt.classList.add("actif")
            let name = portrait.querySelector('.people--name').innerHTML
            let poste = portrait.querySelector('.people--poste').innerHTML
            let id = portrait.querySelector('.people').dataset.id;
            nextElt.querySelector('.people--name').innerHTML = name;
            nextElt.querySelector('.people--poste').innerHTML = poste;
            nextElt.dataset.id = id;
            //nextElt.addEventListener("click", _listener);
        }
        else { //on desactive
            document.querySelector("ul.portraits--content").classList.remove('open');
            if(document.querySelector('.portraits--people.actif')) {
                document.querySelector('.portraits--people.actif').classList.remove('actif');
            }
            if(document.querySelector('.people--infosTablet.actif')) {
                document.querySelector('.people--infosTablet.actif').classList.remove('actif');
            }
            //console.log('ici');
            portrait.classList.remove("actif")
            nextElt.classList.remove("actif")
            nextElt.querySelector('.people--name').innerHTML = '';
            nextElt.querySelector('.people--poste').innerHTML = '';
            nextElt.dataset.id = '';
            
        }
    },
    nextElement: function(elem, selector) {
        let siblings = '';
        elem = elem.nextElementSibling;
    
        while (elem) {
            if (elem.matches(selector)) {
                siblings=elem;
                break;
            }
            elem = elem.nextElementSibling;
        }
        return siblings;
    }
}

Portraits.init();

export default Portraits;



// WEBPACK FOOTER //
// ./src/scripts/components/Portraits.js